import {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/pages/halloween';
import WalletSelector from '../../../../selectors/pages/main/balance';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {useLocation} from 'react-router-dom';

const toNextTicket = amount => {
    const current = Math.floor(amount / 40);
    return parseFloat((40 - (amount - (current * 40))).toFixed(2))
}

export default () => {
    const {halloween} = useSelector(Selector);

    return (
            <div className="h-modal  animate__fadeInUp animate__animated animate__faster">
                <div className="h-header">
                    How to get tickets?
                    <div className="close">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_166_9619)">
                                <path d="M0 14L14 0" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M14 14L0 0" stroke="#DFDFEC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_166_9619">
                                    <rect width="14" height="14" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div className="h-body" style={{display: 'block'}}>
                    You can get a ticket for every <b>$40</b> of your deposits.
                    <br/>
                    You can also invite your friend and get tickets for his deposits!
                </div>
            </div>
    )
}